import { render, staticRenderFns } from "./symptom.vue?vue&type=template&id=73654dfc&"
import script from "./symptom.vue?vue&type=script&lang=js&"
export * from "./symptom.vue?vue&type=script&lang=js&"
import style0 from "./symptom.vue?vue&type=style&index=0&id=73654dfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports